import { useContext } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo.png'
import { MdClose } from "react-icons/md";


export default function SideBar(props) {

  const appContext = useContext(AppContext);
  const menuItems = [
    { item: 'home', label: 'Home' },
    { item: 'books', label: 'Books' },
    { item: 'videos', label: 'Videos' },
    { item: 'journals', label: 'Journals' },
    { item: 'stories', label: 'Stories' },
    { item: 'account', label: 'Account' },
  ];

  function closeSideBar() {
    appContext.setIsSideBarOpen(false);
  }

  function goTo(item) {
    appContext.navTo({
      item,
    })

    if(appContext.isSideBarOpen) {
      closeSideBar();
    } else {
      //..
    }
  }

  return (
    <div
      className="SideBar mShadow2"
      data-open={appContext.isSideBarOpen}
    >
      <div className="body mNoScrollBar">

        <h6
          className="text-end"
          onClick={appContext.closeSideBar}
        >
          <MdClose
            size={32}
            style={{
              cursor: "pointer"
            }}
          />
        </h6>

        <div
          className="logo-holder"
        >
          <img
            src={logo}
            alt="MIKA KENYATA"
          />
        </div>

        {
          menuItems.map((menuItem) => {
            const isActive = (
              appContext.navItem === menuItem.item ||
              (!appContext.navItem && menuItem.item === 'home')
            );

            return (
              <div
                className="pill"
                key={menuItem.item}
                onClick={() => goTo(menuItem.item)}
                data-active={isActive}
              >
                <p className="text">{menuItem.label}</p>
              </div>
            )
          })
        }

      </div>
    </div>
  )
}
